import React from 'react';

interface TextareaFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  helpText?: string;
  rows?: number;
}

const TextareaField: React.FC<TextareaFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  helpText,
  rows = 4,
}) => (
  <label className="block">
    <div className="mb-2 text-[11px] font-semibold uppercase tracking-[0.3em] text-amber-100/55">{label}</div>
    <textarea
      rows={rows}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      placeholder={placeholder}
      className="w-full rounded-2xl border border-white/10 bg-[#120807] px-4 py-3 text-white placeholder:text-white/35 focus:border-amber-400/35 focus:outline-none"
    />
    {helpText && <div className="mt-2 text-sm text-white/45">{helpText}</div>}
  </label>
);

export default TextareaField;

